import React from "react"

import { ContentTag, connect } from "scrivito"

import { useProductObj } from "entities/products/model/useProductObj"

import {
  FollowUpConfigurationRow,
  FollowUpConfigurationRowProps
} from "./FollowUpConfigurationRow"

type FollowUpConfigurationRowConnectorProps = Omit<
  FollowUpConfigurationRowProps,
  "productImage" | "productKind"
>

function FollowUpConfigurationRowConnectorComponent({
  entry,
  ...props
}: FollowUpConfigurationRowConnectorProps) {
  const { productObj } = useProductObj(entry.targetProduct.productName)

  return (
    <FollowUpConfigurationRow
      {...props}
      entry={entry}
      productImage={
        productObj ? (
          <ContentTag alt="" content={productObj} attribute="imageWidgets" />
        ) : undefined
      }
      productKind={productObj?.get("kind") || undefined}
    />
  )
}

export const FollowUpConfigurationRowConnector = React.memo(
  connect(FollowUpConfigurationRowConnectorComponent)
)
